
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./Chatbot.css";

const WhatsappChatbot = () => {
  return (
  <a 
  href="https://wa.me/919651800482"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp_chatbot"
  aria-label="Chat with us on WhatsApp"
>
  {/* Your WhatsApp icon */}

      <FontAwesomeIcon
        icon={faWhatsapp}
        className="whatsapp_icon"
      />
    </a>
  );
};

export default WhatsappChatbot;
